import { formatDate } from "@/lib/utils";
import type { InquiryReply } from "@/services/inquiry-service";

interface MessageBubbleProps {
  reply: InquiryReply;
}

export function MessageBubble({ reply }: MessageBubbleProps) {
  const isUser = reply.sender_role === "user";

  return (
    <div className={`flex flex-col gap-2 ${isUser ? "items-end" : "items-start"}`}>
      {!isUser && (
        <div className="flex items-baseline gap-3">
          <span className="text-sm font-bold text-[#000000]">
            {reply.sender_name}
            <span> (관리자)</span>
          </span>
          <span className="text-xs text-[#000000]">
            {formatDate(reply.created_at, "YYYY-MM-DD HH:mm")}
          </span>
        </div>
      )}
      <div className="max-w-[80%] rounded-[4px] bg-[#00000010] px-4 py-3">
        <p className="whitespace-pre-wrap break-all text-base text-[#202020]">{reply.content}</p>
      </div>
      {isUser && (
        <div className="flex items-baseline gap-3">
          <span className="text-xs text-[#000000]">
            {formatDate(reply.created_at, "YYYY-MM-DD HH:mm")}
          </span>
          {/* <span className="text-sm font-bold text-[#000000]">{reply.sender_name}</span> */}
        </div>
      )}
    </div>
  );
}
